export const sections = [
  {
    id: "leonteios",
    title: "ΛΕΟΝΤΕΙΟΣ ΣΧΟΛΗ ΝΕΑΣ ΣΜΥΡΝΗΣ",
    footerTitle: "Λεόντειος Σχολή Νέας Σμύρνης",
    eyebrowLower: "ΕΙΔΗ ΙΜΑΤΙΣΜΟΥ ΛΕΟΝΤΕΙΟΥ ΣΧΟΛΗΣ ΝΕΑΣ ΣΜΥΡΝΗΣ",
    eyebrowUpper: "ΕΙΔΗ ΙΜΑΤΙΣΜΟΥ ΛΕΟΝΤΕΙΟΥ ΣΧΟΛΗΣ ΝΕΑΣ ΣΜΥΡΝΗΣ",
    description:
      "Επίσημη συλλογή ειδών ρουχισμού και αξεσουάρ για τους μαθητές της Λεοντείου Σχολής Νέας Σμύρνης.",
    path: "/leonteios",
    logo: "/images/logos/leonteios-ns-logo.png",
    sectionLogo: "/images/logos/logo-leonteios-horizontal.png",
    theme: "school",
    dressCode: {
      label: "Προβολή dress code",
      url: "/dress-codes/dress-code-leonteios.pdf"
    }
  },
  {
    id: "panionios-fa",
    title: "PANIONIOS FOOTBALL ACADEMY",
    eyebrowLower: "ΕΙΔΗ ΙΜΑΤΙΣΜΟΥ ΕΞΩΤΕΡΙΚΩΝ ΑΚΑΔΗΜΙΩΝ ΠΑΝΙΩΝΙΟΥ",
    eyebrowUpper: "ΕΙΔΗ ΙΜΑΤΙΣΜΟΥ ΕΞΩΤΕΡΙΚΩΝ ΑΚΑΔΗΜΙΩΝ ΠΑΝΙΩΝΙΟΥ",
    description:
      "Επίσημος ενδυματολογικός κατάλογος για τις ακαδημίες του Εξωτερικού δικτύου ακαδημιών του Πανιωνίου Γ.Σ.Σ.",
    path: "/panionios-fa",
    logo: "/images/logos/panionios-fa-logo.png",
    theme: "academy",
    dressCode: {
      label: "Προβολή dress code",
      url: "/dress-codes/dress-code-pfa.pdf"
    }
  },
  {
    id: "pgss",
    title: "PANIONIOS\nOFFICIAL STORE",
    eyebrowLower: "ΠΑΝΙΩΝΙΟΣ Γ.Σ.Σ. ΚΑΤΑΣΤΗΜΑ",
    eyebrowUpper: "ΕΠΙΣΗΜΟ ΚΑΤΑΣΤΗΜΑ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ ΠΑΝΙΩΝΙΟΥ Γ.Σ.Σ.",
    description:
      "Επίσημα προϊόντα για τον Πανιώνιο Γ.Σ.Σ. Είδη για όλα τα τμήματα ακαδημιών των υποδομών και για τους υποστηρικτές.",
    path: "/pgss",
    logo: "/images/logos/panionios-logo.png",
    theme: "panionios"
  },
  {
    id: "oss",
    title: "OFFICIAL\nSTORE SUPPLIES",
    eyebrowLower: "ΕΙΔΗ ΕΝΔΥΣΗΣ ΚΑΙ ΑΞΕΣΟΥΑΡ ΧΩΡΙΣ ΕΚΤΥΠΩΣΕΙΣ",
    eyebrowUpper: "ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΡΟΥΧΙΣΜΟΥ\nΚΑΙ ΑΞΕΣΟΥΑΡ",
    description:
      "Είδη ένδυσης και αξεσουάρ σε τιμές χονδρικής. Δυνατότητα εκτυπώσεων για αθλητικούς συλλόγους και ιδιώτες.",
    path: "/oss",
    logo: "/images/logos/oss-category.png",
    theme: "school"
  },
  {
    id: "shinpad",
    title: "SHINPAD.GR",
    eyebrowLower: "ΠΡΟΣΩΠΟΠΟΙΗΜΕΝΕΣ ΕΠΙΚΑΛΑΜΙΔΕΣ ΠΟΔΟΣΦΑΙΡΟΥ",
    eyebrowUpper: "ΠΡΟΣΩΠΟΠΟΙΗΜΕΝΕΣ ΕΠΙΚΑΛΑΜΙΔΕΣ ΠΟΔΟΣΦΑΙΡΟΥ",
    description:
      "Προσωποποιημένες επικαλαμίδες με custom σχέδια και χρώματα για αθλητές, ομάδες και συλλόγους.",
    websiteNotice:
      "Το Shinpad θα έχει δική του ιστοσελίδα στο shinpad.gr, η οποία δεν είναι ακόμα διαθέσιμη.",
    path: "/shinpad",
    logo: "/images/logos/shinpad.png",
    theme: "school"
  },
  {
    id: "cosmidis-coating",
    title: "COSMIDIS COATING",
    footerTitle: "Cosmidis Coating - Χρωματιστά Ψυγεία",
    eyebrowLower: "ΕΠΙΣΤΡΩΣΕΙΣ-ΕΠΕΝΔΥΣΕΙΣ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ",
    eyebrowUpper: "ΧΡΩΜΑΤΙΣΤΑ ΨΥΓΕΙΑ - ΕΠΕΝΔΥΣΕΙΣ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ",
    description:
      "Χρωματιστά ψυγεία: ανανεώστε μοναδικά την κουζίνα σας ντύνοντας τις καινούργιες ή παλιές ηλεκτρικές συσκευές σας με χρώμα!",
    path: "https://coating.cosmidis.com/",
    logo: "/images/logos/cosmidis-coating.png",
    logoAlt: "Χρωματιστά ψυγεία Cosmidis Coating",
    theme: "school"
  }
];

export function getSectionById(id) {
  return sections.find((section) => section.id === id);
}
